import type { CompInfo } from '@wix/thunderbolt-becky-root'

export const getRequiredIndicationDisplay = (styleProperties: CompInfo['styleProperties']): string => {
	const { txtlblrq } = styleProperties
	const hasRequiredStyle = txtlblrq !== undefined && txtlblrq !== 'transparent'

	return hasRequiredStyle ? 'inline' : 'none'
}
